import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

// 公告信息
class Announcement {

    // INTF-00427：创建一条公告信息
    createOne(data) {
        let body = data;
        return axios.post(`/myAnnouncementApp/service.AnnouncementProvider/CreateOne`, body);
    }
    // INTF-00429：更新一条公告信息
    updateInfo(data) {
        let body = data;
        return axios.post(`/myAnnouncementApp/service.AnnouncementProvider/UpdateDetails`, body);
    }
    // INTF-00470：删除公告信息
    deleteInfo(ids) {
        let body = { id_arr: ids };
        return axios.post(`/myAnnouncementApp/service.AnnouncementProvider/Delete`, body);
    }
    // INTF-00521：启用/禁用公告信息
    enOrDisableInfo(ids) {
        let body = { id_arr: ids };
        return axios.post(`/myAnnouncementApp/service.AnnouncementProvider/ToggleAnnouncementStatus`, body);
    }
    // INTF-00428：分页查询公告信息
    async getAllInfo(query) {
        let body = query;
        try {
            let res = await axios.post(`/myAnnouncementApp/service.AnnouncementProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.announcement_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get announce list in pages faile: INTF-00428", err);
            return { err: true, msg: err.response.data };
        }
    }

    // INTF-00430：不分页查询所有设置为置顶的所有公告信息
    async getTopInfo() {
        let body = {};
        try {
            let res = await axios.post(`/myAnnouncementApp/service.AnnouncementProvider/TopQuery`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.announcement_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get topinfo list in no page failed: INTF-00430", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00431：不分页查询一个月中不置顶的公告信息且当前状态为已发布已启用
    async getUntopInfoInMounth() {
        let body = {};
        try {
            let res = await axios.post(`/myAnnouncementApp/service.AnnouncementProvider/MonthTopQuery`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.announcement_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get untop info list in no page failed: INTF-00431", err);
            return { err: true, msg: response.data };
        }
    }
}

export default Announcement;